import React, { useState } from 'react';
import { api } from '../../services/api';
import AttachmentGallery from './AttachmentGallery';

/**
 * Shows a 📎 icon if request has attachments. Click opens gallery.
 * canDelete = true only if request is Open and user owns it.
 */
export default function AttachmentIcon({ paymentRequestId, hasAttachments, user, canDelete }) {
  const [attachments, setAttachments] = useState(null);
  const [showGallery, setShowGallery] = useState(false);

  if (!hasAttachments) return null;

  const handleClick = async (e) => {
    e.stopPropagation();
    if (!attachments) {
      const data = await api.getAttachments(user.credential, paymentRequestId);
      setAttachments(data);
    }
    setShowGallery(true);
  };

  const handleDelete = (deletedId) => {
    setAttachments(prev => prev.filter(a => a.id !== deletedId));
  };

  return (
    <>
      <button onClick={handleClick} style={btnStyle} title="צרופות">📎</button>

      {showGallery && attachments && attachments.length > 0 && (
        <AttachmentGallery
          attachments={attachments}
          user={user}
          canDelete={canDelete}
          onDelete={handleDelete}
          onClose={() => setShowGallery(false)}
        />
      )}
    </>
  );
}

const btnStyle = {
  background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', padding: '2px',
};
